import { useSearchParams } from "react-router-dom";
import { PageHeader } from "@/components/Common";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { InvoicesTab } from "@/components/accounting/InvoicesTab";
import { ScheduleTab, FirstNoteTab } from "@/components/accounting/ScheduleTab";
import { BefTab } from "@/components/accounting/BefTab";

export default function Accounting() {
  const [params] = useSearchParams();
  const tab = params.get("tab") || "out";
  return (
    <div data-testid="accounting-page">
      <PageHeader eyebrow="Fatture, scadenze e prima nota" title="Amministrazione" />
      <Tabs key={tab} defaultValue={tab}>
        <TabsList className="mb-4 h-auto flex-wrap">
          <TabsTrigger value="out" data-testid="accounting-tab-out">Fatture attive</TabsTrigger>
          <TabsTrigger value="in" data-testid="accounting-tab-in">Fatture passive</TabsTrigger>
          <TabsTrigger value="schedule" data-testid="accounting-tab-schedule">Scadenziario</TabsTrigger>
          <TabsTrigger value="note" data-testid="accounting-tab-note">Prima nota</TabsTrigger>
          <TabsTrigger value="bef" data-testid="accounting-tab-bef">BEF intercompany</TabsTrigger>
        </TabsList>
        <TabsContent value="out"><InvoicesTab direction="OUT" /></TabsContent>
        <TabsContent value="in"><InvoicesTab direction="IN" /></TabsContent>
        <TabsContent value="schedule"><ScheduleTab /></TabsContent>
        <TabsContent value="note"><FirstNoteTab /></TabsContent>
        <TabsContent value="bef"><BefTab /></TabsContent>
      </Tabs>
    </div>
  );
}
